export default {
  en: {
    CAMPAIGN_STEP_SHAREABLE_TAGS_HEADER: 'Shareable Tags',
    CAMPAIGN_STEP_SHAREABLE_TAGS_MESSAGE:
      'Selecting tags allows them to be shared with other Ringba accounts.',
    CAMPAIGN_STEP_SHAREABLE_TAGS_LABEL: 'Override Shareable Tags',
    CAMPAIGN_STEP_SHAREABLE_TAGS_LABEL_TARGET_TT:
      'Tags selected will override settings at the buyer and campaign levels.',
    CAMPAIGN_STEP_SHAREABLE_TAGS_LABEL_BUYER_TT:
      'Tags selected will override settings at the campaign level.',
    CAMPAIGN_STEP_SHAREABLE_TAGS_SHARE_CALL_ID: 'Share Inbound Call ID',
    CAMPAIGN_STEP_SHAREABLE_TAGS_SHARE_CALL_ID_TT:
      'If enabled, the inbound call id will be shared with your buyer as tag \'publisherInboundCallId\'',
    BUYER_EXTRA_TAGS: 'Allow Buyers to See Selected Tags',
    BUYER_EXTRA_TAGS_TT:
      'Once enabled you will be able to add the ability to all buyers in your account to see the selected tags below.',
    BUYER_EXTRA_TAGS_OPTIONS: 'Allowed Tags in Buyers View',
    BUYER_EXTRA_TAGS_OPTIONS_TT:
      'Choose which extra tags buyers will see in reporting page.',
    BUYER_EXTRA_TAGS_SELECT_A_TAG: 'Select a tag',
    BUYER_EXTRA_TAGS_SELECTED_TAGS: 'Selected tags:'
  }
};
